module.exports = __webpack_public_path__ + "img/placeholder.66956e49.jpg";